var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop",
              attrs: {
                title: _vm.$t("userCenter.childrenUserManage.addDialogText"),
                isShowFollow: false,
                width: "500px",
              },
              on: { open: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-form",
                  {
                    ref: "formAddChildrenRef",
                    attrs: {
                      model: _vm.formAddChildren,
                      rules: _vm.rules,
                      "label-width": "100px",
                      "label-position": "top",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "regired ",
                        attrs: {
                          label: _vm.$t(
                            "userCenter.childrenUserManage.addDialogRole"
                          ),
                          prop: "portData",
                        },
                      },
                      [
                        _c("gl-port-role", {
                          attrs: {
                            accountNo: _vm.userInfo.accountNo,
                            roleCode: _vm.formAddChildren.roleObject.roleCode,
                          },
                          on: { change: _vm.selectPortChange },
                          model: {
                            value: _vm.formAddChildren.portData,
                            callback: function ($$v) {
                              _vm.$set(_vm.formAddChildren, "portData", $$v)
                            },
                            expression: "formAddChildren.portData",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "regired ",
                        attrs: {
                          label: _vm.$t(
                            "userCenter.childrenUserManage.addDialogPort"
                          ),
                          prop: "portObject",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.formAddChildren.portCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.formAddChildren, "portCode", $$v)
                            },
                            expression: "formAddChildren.portCode",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "regired ",
                        attrs: {
                          label: _vm.$t(
                            "userCenter.childrenUserManage.addDialogOrganization"
                          ),
                          prop: "portObject",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.formAddChildren.officeAbbrev,
                            callback: function ($$v) {
                              _vm.$set(_vm.formAddChildren, "officeAbbrev", $$v)
                            },
                            expression: "formAddChildren.officeAbbrev",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dialog-button-bottom" },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "70px" },
                        attrs: { size: "medium", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.addChildrenPostClick()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("userCenter.editFormDialog.saveButton")
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }